export const SocketChannelNamespaceType = {
    CORE: "CORE",
    SYNC: "SYNC",
    PRIVATE: "PRIVATE",
    // Legacy AI assistant only: hqb-ai-agent publishes on, and scopes its Ably
    // tokens to, `<namespace>:<clientId>`.
    AI_ASSISTANT: "AI_ASSISTANT",
};
